import axios from 'axios';
import { API_URL } from '../../utils/constants';

// Public catalog endpoints require no authentication.
// Use a dedicated axios instance without the auth interceptors.
const publicClient = axios.create({
  baseURL: `${API_URL}/public/catalog`,
  timeout: 12000,
});

/**
 * Fetch the product list for a store.
 * @param {string} slug  - Store slug
 * @param {{ pagina, limite, busqueda, categoria }} opts
 * @param {AbortSignal} [signal]
 */
export const getCatalog = (slug, opts = {}, signal) => {
  const { pagina = 1, limite = 24, busqueda = '', categoria = '' } = opts;
  const params = { pagina, limite };
  if (busqueda)  params.busqueda  = busqueda;
  if (categoria) params.categoria = categoria;
  return publicClient.get(`/${slug}`, { params, signal }).then((r) => r.data);
};

/**
 * Fetch a single product detail.
 * @param {string} slug
 * @param {string} productId
 * @param {AbortSignal} [signal]
 */
export const getProducto = (slug, productId, signal) =>
  publicClient.get(`/${slug}/p/${productId}`, { signal }).then((r) => r.data);
